import { render, staticRenderFns } from "./modalErrorIndividual.vue?vue&type=template&id=3b2a5ad8&scoped=true&"
import script from "./modalErrorIndividual.vue?vue&type=script&lang=js&"
export * from "./modalErrorIndividual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2a5ad8",
  null
  
)

export default component.exports